import type { ReleaseManifest } from "../types";

function validAssetUrl(value: string): boolean {
  return value.startsWith("https://github.com/")
    || value.startsWith("https://blockr.mashr.ai/downloads/");
}

export async function loadReleaseManifest(signal?: AbortSignal): Promise<ReleaseManifest> {
  const response = await fetch("/releases/latest.json", { signal, cache: "no-store" });
  if (!response.ok) throw new Error("The release manifest is unavailable.");
  const payload = (await response.json()) as ReleaseManifest;
  if (payload.available) {
    if (!payload.prerelease || !payload.tag || !payload.targets.length) {
      throw new Error("The release manifest failed validation.");
    }
    for (const target of payload.targets) {
      if (target.bytes <= 0
        || !target.sha256.match(/^[a-f0-9]{64}$/)
        || !validAssetUrl(target.archiveUrl)
        || !validAssetUrl(target.checksumUrl)
        || !validAssetUrl(target.sigstoreUrl)) {
        throw new Error("The release manifest contains an invalid asset.");
      }
    }
  }
  return payload;
}
